import React from 'react'
import GuideListData from './table/GuideListData'
import { useNavigate } from "react-router-dom";

export default function GuideList() {
  const Navigate = useNavigate();
  return (
    <div>
  <div className='flex flex-wrap w-fit ml-auto'>
    <button
    type="button"
   onClick={()=>{Navigate("/dashboard/guide/add-guide")}}
    className="border-2 border-blue-200 hover:text-white text-base font-Montserrat font-bold text-blue-200 flex-shrink hover:border-blue-100 hover:bg-blue-100 place-content-center rounded-md px-2 py-1 flex flex-grow w-60 "
  >
    Add Guide
  </button>
  </div>
  <div className="flex flex-wrap justify-center">
  <div
    className="tabelcontainer flex-auto  overflow-auto "
    // "w-[calc(100vw_-_12rem)]"
  >
    {/* <Itemsdata /> */}
    <GuideListData />
  </div>
</div>
    
    </div>
  )
}
